import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { iconsOptions } from 'projects/app-default/src/app/styles/cms.config';

export namespace NCmsInformationFaq {
    export const componentId = 'information-faq';
    export interface IItem {
        icon: string;
        title: string;
        components?: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        items: IItem[];
    }
}

let uid = 0;

@ICmsComponent<CmsInformationFaqComponent>({
    id: NCmsInformationFaq.componentId,
    name: 'Information FAQ',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'Item',
            itemNameField: 'title',
            defaultSize: 1,
            required: true,
            fields: [
                {
                    type: NICmsContentField.EFieldType.choice,
                    key: 'icon',
                    title: 'Icon',
                    itemName: 'icon',
                    options: iconsOptions,
                    previewMode: 'icon',
                    default: 'icon-phone',
                    required: true
                },
                {
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    default: 'Title',
                    required: true
                },
                <NICmsContentField.IComponentsField>{
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Content components',
                    itemName: 'component',
                    default: []
                }
            ],
            default: [
                { title: 'Popular', components: [], icon: 'icon-wishlist-fill' },
                { icon: 'icon-trending', title: 'Product & Stock', components: [] },
                { icon: 'icon-delivery', title: 'Delivery', components: [] },
                { icon: 'icon-rotate', title: 'Returns & Refunds', components: [] },
                { icon: 'icon-promo', title: 'Payments & Promos', components: [] },
                { icon: 'icon-settings', title: 'Technical', components: [] }
            ]
        }
    ]
})
@Component({
    imports: [ImageModule, ICmsClientModule, ToggleModule],
    selector: 'cms-information-faq',
    templateUrl: './cms-information-faq.html',
    styleUrl: './cms-information-faq.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsInformationFaqComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsInformationFaq.IComponentData;

    readonly groupId = `cmsInformationFaq${uid++}`;

    private toggleService = inject(ToggleService);

    open(index: number): void {
        this.toggleService.toggle([this.groupId, index]);
    }
}
